import { type SegmentedControlProps, SegmentGroup } from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends Omit<SegmentedControlProps, 'value' | 'onChange'> {
  name: string;
}

export const HookedSegmentGroup = (props: Props) => {
  const { name, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  return <SegmentGroup {...rest} {...inputProps} />;
};
